"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = exports.pluralize = exports.formatPrice = exports.capitalize = void 0;
var slugify_1 = __importDefault(require("@sindresorhus/slugify"));
var capitalize = function (str) {
    if (str === void 0) { str = ''; }
    return str.charAt(0)
        .toUpperCase() + str.slice(1);
};
exports.capitalize = capitalize;
var formatPrice = function (price, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.unit, unit = _c === void 0 ? '€' : _c, freeString = _b.freeString;
    if (!price)
        return undefined;
    var numericalPrice = Number(price)
        .toFixed(2)
        .replace('.', ',');
    var formattedPrice = numericalPrice.endsWith(',00') ? numericalPrice.slice(0, -3) : numericalPrice;
    if (formattedPrice === '0' && freeString)
        return freeString;
    return "".concat(formattedPrice).concat(unit);
};
exports.formatPrice = formatPrice;
var pluralize = function (value, singular, plural) {
    if (plural === void 0) { plural = "".concat(singular, "s"); }
    return "".concat(value, " ").concat(value > 1 ? plural : singular);
};
exports.pluralize = pluralize;
var slugify = function (str) {
    if (str === void 0) { str = ''; }
    return (0, slugify_1.default)(str);
};
exports.slugify = slugify;
exports.default = { capitalize: exports.capitalize, formatPrice: exports.formatPrice, pluralize: exports.pluralize, slugify: exports.slugify };
//# sourceMappingURL=Formatting.js.map